/**
 * Platform-wide primary navigation (spec §5 — nav patterns are fixed
 * platform-wide, not per-org). v1 reference style: NO "Home" item — the header
 * and footer logos link home instead (so the Footer's no-footer-links fallback,
 * which maps this list, intentionally has no Home link either).
 */
export interface ShellNavLink {
  label: string;
  href: string;
}

/** Trusted Only owns profile settings for every signed-in Agent Directory role. */
export const TO_SETTINGS_PROFILE_URL =
  "https://app.trustedonly.com/settings/profile";

export const AD_NAV_LINKS: readonly ShellNavLink[] = [
  { label: "Find an Agent", href: "/agents" },
  { label: "Open Houses", href: "/open-houses" },
  { label: "Trusted Vendors", href: "/vendors" },
];

/**
 * The nav renders /agents as the solid CTA pill ("Find an Agent"), so the text
 * link rows skip it to avoid two adjacent identical links. The Footer still maps
 * the FULL list (both links).
 */
export const AD_NAV_CTA: ShellNavLink = AD_NAV_LINKS[0]!;
export const AD_NAV_TEXT_LINKS: readonly ShellNavLink[] = AD_NAV_LINKS.filter(
  (l) => l.href !== AD_NAV_CTA.href,
);

/**
 * Prefix a logical href with the dev path-based routing base (`/${slug}`).
 * Empty `basePath` (subdomain prod) returns the href unchanged. Mirrors the
 * OrgPortal NavBar dev-prefix pattern (lesson 2026-03-30 — `router.push`/`Link`
 * drops the org prefix in dev path-based routing).
 */
export function withBasePath(basePath: string, href: string): string {
  if (!basePath) return href;
  return href === "/" ? `${basePath}/` : `${basePath}${href}`;
}
